module.exports = __webpack_public_path__ + "static/media/hydrocal.f4e45752.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/en/hydrocal.png
// module id = 102
// module chunks = 0